import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import WelcomeScreen from '../components/onboarding/WelcomeScreen';
import BirthDetailsForm from '../components/onboarding/BirthDetailsForm';
import HumanDesignProfile from '../components/onboarding/HumanDesignProfile';
import SchwartzValuesTest from '../components/onboarding/SchwartzValuesTest';
import GoalsPrompt from '../components/onboarding/GoalsPrompt';
import ProfileSummary from '../components/onboarding/ProfileSummary';
import LoginForm from '../components/onboarding/LoginForm';
import { useUser } from '../context/UserContext';
import { trackEvent } from '../services/AnalyticsService';
import { Flower2Icon, LeafIcon } from 'lucide-react';
interface OnboardingPageProps {
  onComplete?: () => void;
}
const OnboardingPage: React.FC<OnboardingPageProps> = ({
  onComplete
}) => {
  const [step, setStep] = useState(0);
  const [showLogin, setShowLogin] = useState(false);
  const {
    updateUserData
  } = useUser();
  const navigate = useNavigate();
  const nextStep = () => {
    trackEvent('onboarding_step_completed', {
      step: step,
      stepName: stepNames[step]
    });
    setStep(step + 1);
  };
  const handleComplete = () => {
    trackEvent('onboarding_completed', {});
    if (onComplete) {
      onComplete();
    } else {
      navigate('/dashboard');
    }
  };
  const handleLoginSuccess = () => {
    if (onComplete) {
      onComplete();
    } else {
      navigate('/dashboard');
    }
  };
  const toggleLoginView = () => {
    setShowLogin(!showLogin);
    trackEvent('login_view_toggled', {
      showLogin: !showLogin
    });
  };
  const stepNames = ['welcome', 'birth_details', 'human_design', 'values_test', 'goals', 'summary'];
  const steps = [<WelcomeScreen onContinue={nextStep} onLoginClick={toggleLoginView} key="welcome" data-id="element-868" />, <BirthDetailsForm onContinue={nextStep} key="birth" data-id="element-869" />, <HumanDesignProfile onContinue={nextStep} key="human-design" data-id="element-870" />, <SchwartzValuesTest onContinue={nextStep} key="values" data-id="element-871" />, <GoalsPrompt onContinue={nextStep} key="goals" data-id="element-872" />, <ProfileSummary onComplete={handleComplete} key="summary" data-id="element-873" />];
  return <div className="min-h-screen flex flex-col justify-center items-center relative" data-id="element-874">
      {/* Decorative elements */}
      <div className="absolute top-10 right-10 text-green-200 opacity-30 transform rotate-15" data-id="element-875">
        <Flower2Icon size={80} data-id="element-876" />
      </div>
      <div className="absolute bottom-10 left-10 text-green-200 opacity-30 transform -rotate-15" data-id="element-877">
        <LeafIcon size={80} data-id="element-878" />
      </div>
      <div className="absolute top-1/3 left-5 text-green-200 opacity-20" data-id="element-879">
        <LeafIcon size={60} data-id="element-880" />
      </div>
      <div className="absolute bottom-1/3 right-5 text-green-200 opacity-20" data-id="element-881">
        <Flower2Icon size={60} data-id="element-882" />
      </div>
      <div className="w-full max-w-md bg-white rounded-lg shadow-lg p-6 my-8 relative" data-id="element-883">
        {/* Card decorative elements */}
        <div className="absolute -top-3 -left-3 text-green-400 opacity-70" data-id="element-884">
          <LeafIcon size={24} data-id="element-885" />
        </div>
        <div className="absolute -bottom-3 -right-3 text-green-400 opacity-70" data-id="element-886">
          <Flower2Icon size={24} data-id="element-887" />
        </div>
        {showLogin ? <LoginForm onLoginSuccess={handleLoginSuccess} onBackToSignup={toggleLoginView} data-id="element-888" /> : <>
            {steps[step]}
            <div className="mt-8 flex justify-center" data-id="element-889">
              <div className="flex space-x-2" data-id="element-890">
                {steps.map((_, index) => <div key={index} className={`h-2 w-2 rounded-full ${index === step ? 'bg-green-500' : 'bg-gray-300'}`} data-id="element-891" />)}
              </div>
            </div>
          </>}
      </div>
      {/* Bottom decorative divider */}
      <div className="flex items-center justify-center w-full max-w-md mt-4" data-id="element-892">
        <div className="h-px bg-gradient-to-r from-transparent via-green-300 to-transparent w-1/3" data-id="element-893"></div>
        <Flower2Icon size={16} className="mx-2 text-green-400" data-id="element-894" />
        <div className="h-px bg-gradient-to-r from-transparent via-green-300 to-transparent w-1/3" data-id="element-895"></div>
      </div>
    </div>;
};
export default OnboardingPage;